export const GET_RATES = 'interest-rates/GET_RATES'
export const ADD_RATES = 'interest-rates/ADD_RATES'
export const SIMULATE_API_FOR_INDEX = 'interest-rates/SIMULATE_API_FOR_INDEX'
export const EDIT_RATES = 'interest-rates/EDIT_RATES'
